import React from 'react';
import { connect } from 'react-redux';
import { FormControlLabel, Checkbox, Grid, Tooltip, IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

const SelectAllFormControl = withStyles(FormControlLabel, {
    root: {
        margin: 0,
        marginRight: 8,
        display: 'flex',
        alignItems: 'center'
    },
    label: {
        fontSize: '10pt'
    }
});

const TimelineTopBar = (props) => {
    const { lyricsSelectAllEnabled, selectOrDeselectSegments, lyricsSegmentsLength, deleteSelectedSegments, checkedSegmentsLength } = props;

    const onSelectAllCheckboxChange = (event) => {
        selectOrDeselectSegments(event.target.checked);
    };

    return (
        <Grid 
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'
            wrap='nowrap'
        >
            <Grid item>
                <Tooltip title='Delete Selected' placement='right'>
                    <span>
                        <IconButton
                            size='small'
                            onClick={deleteSelectedSegments}
                            disabled={!Boolean(checkedSegmentsLength)}
                            aria-label='delete selected lyric segments'
                            sx={{
                                padding: '5px',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.08)'
                                },
                                '&.Mui-disabled': {
                                    color: 'rgba(255, 255, 255, 0.3)'
                                }
                            }}
                        >
                            <DeleteRoundedIcon fontSize='small' />
                        </IconButton>
                    </span>
                </Tooltip>
            </Grid>
            <Grid item>
                <Tooltip 
                    title={lyricsSelectAllEnabled ? 'Deselect All' : 'Select All'} 
                    placement='right'
                >
                    <SelectAllFormControl
                        checked={lyricsSelectAllEnabled && Boolean(checkedSegmentsLength)}
                        disabled={!Boolean(lyricsSegmentsLength)}
                        control={
                            <Checkbox
                                color='default'
                                size='small'
                                sx={{
                                    padding: '5px',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.08)'
                                    }
                                }}
                            />
                        }
                        label=''
                        labelPlacement="start"
                        onChange={onSelectAllCheckboxChange}
                        aria-label='select segments / deselect segments'
                        sx={{
                            ".Mui-disabled": {
                                color: "rgba(255, 255, 255, 0.3)",
                                backgroundColor: "transparent"
                            }
                        }}
                    />
                </Tooltip>
            </Grid>
        </Grid>
    );
}

const mapStateToProps = (state) => {
    const { lyricsSelectAllEnabled } = state.createPreview.present;
    const { segments } = state.createPreview.present.videoSettings.lyrics;
    const { length: lyricsSegmentsLength } = segments;
    const checkedSegmentsLength = segments.filter(s => Boolean(s.checked)).length;

    return { 
        lyricsSelectAllEnabled,
        lyricsSegmentsLength,
        checkedSegmentsLength
    };
}

const mapDispatchToProps = (dispatch) => {
    const selectOrDeselectSegments = (lyricsSelectAllEnabled) => dispatch(createActions.selectOrDeselectSegments(lyricsSelectAllEnabled));

    const deleteSelectedSegments = () => dispatch((innerDispatch, getState) => {
        const segments = getState().createPreview.present.videoSettings.lyrics.segments;
        const checkedSegments = segments.filter(s => Boolean(s.checked));
        if (checkedSegments.length) {
            innerDispatch(createActions.removeLyricsSegments(checkedSegments));
        }
    });

    return {
        selectOrDeselectSegments,
        deleteSelectedSegments
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimelineTopBar);